<template>
    <form-accordion
        name="contact-information"
        section="Contact Information"
        :url="url"
        method="patch"
        :closed="closed"
        :collapsible="accordion"
        :include_discard_button="include_discard_button"
    >
        <broker-name
            :broker="broker"
        />

        <broker-email
            :broker="broker"
            :read_only="! email_editable"
        />

        <broker-phone
            :settings="settings"
        />

        <account-user-role
            :role="account_user_role"
            @change="roleChanged"
        />

        <office-information
            v-if="role === 'agent_or_broker'"
            :settings="settings"
        />

        <broker-mls
            v-if="role === 'agent_or_broker'"
            :settings="settings"
        />
    </form-accordion>
</template>

<script>
import BrokerName from './broker-name.vue';
import BrokerEmail from './broker-email.vue';
import BrokerPhone from './broker-phone.vue';
import AccountUserRole from './account-user-role.vue';
import BrokerMls from './broker-mls.vue';
import OfficeInformation from './office-information.vue';

export default {
    components: {
        BrokerName,
        BrokerEmail,
        BrokerPhone,
        AccountUserRole,
        BrokerMls,
        OfficeInformation,
    },

    props: {
        closed: { default: true },
        url: {},
        broker: {},
        settings: {},
        accordion: { default: true },
        include_discard_button: { default: true },
        email_editable: { default: true },
        account_user_role: {},
    },

    data() {
        return {
            role: this.account_user_role,
        }
    },

    methods: {
        roleChanged(role) {
            this.role = role;
            this.$emit('roleChanged', role);
        },
    },
}
</script>
